import request from "@/utils/request";

export default data =>
  request({
    method: "post",
    url: "/plm/okn/ijb/fsdfrererdfdf",
    data,
  });
